import gql from 'graphql-tag';

export const GET_DEPARTMENTS = gql`
  query Departments($input: DepartmentsInput!) {
    departments(input: $input) {
      id
      name
    }
  }
`;
